module.exports = __webpack_public_path__ + "static/media/ky.532f970c.svg";